<template>
  <div class="CompanyProfile">
    <Title :title="title" />
    <div class="container flex flex-wrap">
      <div class="content wow fadeInLeft" data-wow-offset="400">
        <p>{{$t('about.CompanyProfile[0]')}}</p>
        <p>{{$t('about.CompanyProfile[1]')}}</p>
        <p>{{$t('about.CompanyProfile[2]')}}</p>
        <p>{{$t('about.CompanyProfile[3]')}}</p>
      </div>
      <div class="video wow fadeInRight" data-wow-offset="400">
        <video :src="lang=='zh-CN'?'http://donghao.chinadonghao.com/video/donghao.mp4':'http://donghao.chinadonghao.com/video/endonghao.mp4'" controls></video>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '../Title/Title.vue'
import { mapState } from "vuex";
export default {
  components: {
    Title
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
    })
  },
  data() {
    return {
      title: {
        cn: '企业简介',
        en: 'company profile'
      }
    }
  }
}
</script>

<style scoped>
.CompanyProfile .container{
  max-width: 1500px;
  margin: 0 auto;
  padding: 50px 0;
  flex-wrap: wrap;
}
.CompanyProfile .container .content{
  width: 52%;
  font-size: 14px;
  color: #1e1e1e;
  line-height: 40px;
}
.CompanyProfile .container .video{
  width: 44.8%;
  margin-left: 3.2%;
}
.CompanyProfile .container .video video{
  display: block;
  width: 100%;
}
@media (max-width: 768px){
  .CompanyProfile .container{
    padding-bottom: 0;
  }
  .CompanyProfile .container .content,
  .CompanyProfile .container .video{
    width: 100%;
    margin-left: 0;
  }
  .CompanyProfile .container .content{
    padding: 20px;
  }
  .CompanyProfile .container .video img{
    width: 100%;
  }
}
</style>


